<footer>
  <div class="content d-flex align-items-center">
    <div class="container d-flex justify-content-between links flex-column flex-lg-row p-4 p-lg-0">
      <div class="d-flex align-items-center justify-content-center">
        <img src="assets/images/svg/logo-dark.svg" alt="logo" class="logo">
      </div>
      <div class="d-flex flex-column text-center text-lg-start mt-5 mt-lg-0">
        <p class="subtitle font-medium">Enlaces</p>
        <a class="text-decoration-none" [href]="environment.redirectHome + '/tasas-y-tarifas/'">Tasas y
          tarifas</a>
        <a class="text-decoration-none" [href]="environment.redirectHome + '/terminos-y-condiciones/'">Términos y
          condiciones</a>
        <a class="text-decoration-none" [href]="environment.redirectHome + '/politicas-de-privacidad/'">Políticas de
          privacidad</a>
        <a class="text-decoration-none" [href]="environment.redirecComplaints">Libro de reclamaciones</a>
      </div>
      <div class="d-flex flex-column text-center text-lg-start mt-5 mt-lg-0">
        <p class="subtitle font-medium">Contáctanos</p>
        <a>Correo: contact@credimovil.com</a>
        <a>WhatsApp: 987654321</a>
        <a></a>
        <div class="social-networks d-flex">
          <a class="me-2 me-lg-0" *ngIf="link.FACEBOOK" [href]="link.FACEBOOK" target="_blank">
            <img src="./assets/images/svg/fb.svg" alt="facebook">
          </a>

          <a class="me-2 me-lg-0" *ngIf="link.TIKTOK" [href]="link.TIKTOK" target="_blank">
            <img src="./assets/images/svg/tk.svg" alt="instagram">
          </a>

          <a *ngIf="link.WHATSAPP" [href]="link.WHATSAPP" target="_blank">
            <img src="./assets/images/svg/wsp.svg" alt="youtube">
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="rights-content d-flex align-items-center justify-content-center">
    <p class="text mb-0">© Todos los derechos resevados</p>
  </div>
</footer>
